import generateRandomHash from 'helpers/generateRandomHash';
import kyWithSentry from './helper/kyWithSentry';
import { ICertificationSettings } from 'components/Certification/shared';
import { EntityTypes } from 'context/entityContext';
import { entityTypeToApiType } from './../mapEntityTypes';

export const TEMPLATE_ID = 'certification_template';

interface ICertificationArgs {
  method: 'post' | 'delete' | 'get';
  certificateData?: ICertificationSettings;
  annotationIds?: string[];
  entityType: EntityTypes;
  entityId: string;
}

const certElements = [
  'certification_type',
  'certification_date',
  'certification_quantity',
  'certification_country',
];

const preparePostBody = (data: ICertificationSettings): any => {
  const notNullElements = certElements.filter(
    (el: string) => data[el] !== undefined && data[el] !== null
  );
  const body = {
    id: generateRandomHash(),
    templateId: TEMPLATE_ID,
    elements: [
      ...notNullElements.map((el: any) => ({
        id: el,
        values: [data[el]],
      })),
    ],
  };
  return body;
};

const certificationInterceptor = async (
  input: RequestInfo /* eslint-disable-line */,
  init: RequestInit | undefined /* eslint-disable-line */,
  interceptionData: ICertificationArgs
): Promise<Response> => {
  const {
    certificateData,
    annotationIds,
    method,
    entityType,
    entityId,
  } = interceptionData;

  const url = `/api/annotations/${entityTypeToApiType(
    entityType
  )}/${entityId}/templates/${TEMPLATE_ID}`;

  try {
    if (method === 'post' && certificateData) {
      const body = preparePostBody(certificateData);

      const response = await kyWithSentry.post(url, { json: body }).json();
      return new Response(JSON.stringify(response));
    } else if (method === 'delete' && annotationIds) {
      try {
        for (const annotationId of annotationIds) {
          await kyWithSentry
            .delete(
              `/api/annotations/${annotationId}/${entityTypeToApiType(
                entityType
              )}/${entityId}/templates/${TEMPLATE_ID}`
            )
            .json();
        }
        return new Response(JSON.stringify({ deletedId: annotationIds[0] }));
      } catch (error) {
        return new Response(error as any);
      }
    } else {
      // get
      const response = await kyWithSentry.get(url).json();
      return new Response(JSON.stringify(response));
    }
  } catch (error) {
    return new Response(JSON.stringify({ reason: error.message }));
  }
};

export default certificationInterceptor;
